exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-icon, .fas {\n    color:'#3B444B';\n    font-size: '14px';\n}", ""]);

// exports
